<script lang="ts">
  export let invert = false;
  export let textPosition: string;
  export let textWithCta: boolean;
</script>

<style lang="scss">
  .divider {
    width: 28px;
    height: 4px;
    background-color: $on-surface;
    margin: 24px 0;
    display: inline-block;
    position: relative;

    @include breakpoint(md) {
      width: 64px;
      height: 8px;
    }
    &--light {
      background-color: $inverse-on-surface;
    }
    &--dark {
      background-color: $on-surface;
    }
    &--left,
    &--right {
      margin-left: 0;
    }
    &--center {
      margin-left: auto;
      margin-right: auto;
    }
    &--cta {
      margin-bottom: 8px;
    }
  }
</style>

<div
  class={`divider ${invert ? "divider--light" : "divider--dark"} ${
    textWithCta ? "divider--cta" : "divider"
  } divider--${textPosition}`}
/>
